import { resolvePlantLoanPlan } from "../../../../infrastructure/utils/plantLoanPlans";
import { formatCurrency } from "../../../../infrastructure/utils/formatters";

const POWER_PLANT_TYPE_BY_NAME = {
  GridConnected: "1",
  OffGrid: "2",
  Hybrid: "3",
  HybridWithoutBattery: "4",
};

function normalizePlantType(raw) {
  if (raw == null || raw === "") return "";
  const str = String(raw).trim();
  if (/^\d+$/.test(str)) return str;
  return POWER_PLANT_TYPE_BY_NAME[str] || "";
}

/** Display-only loan summary from plant type (tracking page). */
export function buildLoanSummary(request) {
  const plantType = normalizePlantType(
    request?.powerPlantType ?? request?.PowerPlantType
  );
  const plan = resolvePlantLoanPlan(plantType);

  if (!plantType) {
    return {
      show: true,
      active: false,
      title: "اطلاعات مالی و وام مهرسان",
      note: "پس از ثبت نوع نیروگاه، اطلاعات وام نمایش داده می‌شود.",
      loanTypeLabel: "—",
      ceilingLabel: "—",
      installmentLabel: "—",
      monthsLabel: null,
    };
  }

  if (!plan.available) {
    return {
      show: true,
      active: false,
      title: "اطلاعات مالی و وام مهرسان",
      note: plan.unavailableMessage,
      loanTypeLabel: plan.planTitle || "آفگرید",
      ceilingLabel: "—",
      installmentLabel: "—",
      monthsLabel: null,
    };
  }

  return {
    show: true,
    active: true,
    title: "اطلاعات مالی و وام مهرسان",
    loanTypeLabel: plan.planTitle,
    ceilingLabel: formatCurrency(plan.maxLoanAmount),
    monthsLabel: `${plan.months.toLocaleString("fa-IR")} ماه`,
    installmentLabel: formatCurrency(plan.monthlyInstallment),
    note: null,
  };
}
